// extracted by mini-css-extract-plugin
export default {"genericCard":"ro-z","inline":"so-z","mastercard":"to-z","discover":"uo-z","visa":"vo-z","amex":"wo-z","active":"xo-z"};